import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const AllTicketTypeList =(params) => AxiosClient.get('/ticket-types', params);
export {
    AllTicketTypeList,
}